export default "__VITE_ASSET__vSGeh5$2__"